// extracted by mini-css-extract-plugin
module.exports = {"container":"partials-patched-text-container","inner":"partials-patched-text-inner","background":"partials-patched-text-background","label":"partials-patched-text-label"};